<template>
  <div>
    <div
      v-if="label"
      class="gl-input__label mb-2"
    >
      {{ label }}
    </div>
    <vSelect
      v-if="hasMultyCoin"
      ref="coinSelectBaseRef"
      v-model="coin"
      class="coin-select-base"
      :class="[
        { 'coin-select-base__dark': dark },
        { 'coin-select-base__small': small },
      ]"
      :clearable="false"
      label="label"
      :options="currencyList"
      :searchable="false"
      @close="isSelectOpen = false"
      @input="handleCoinSelect"
      @open="isSelectOpen = true"
    >
      <template 
        v-if="!isMobileNew" 
        #list-header
      >
        <div class="coin-select-base__header">
          <div class="coin-select-base__header-text">
            Choose Blockchain
          </div>
          <div 
            class="coin-select-base__header-close"
            @click="closeSelect"
          >
            <gl-icon
              :height="12"
              name="close"
              :width="12"
            />
          </div>
        </div>
      </template>
      <template #selected-option="{ label, key }">
        <gl-blockchain-icon :blockchain-icon="key" />
        <div v-if="isMobileNew">
          {{ label }}
        </div>
      </template>
      <template #option="{ label, key }">
        <gl-blockchain-icon :blockchain-icon="key" />
        <div>{{ label }}</div>
      </template>
    </vSelect>
    <div
      v-if="isSelectOpen && !isMobileNew" 
      class="gl-input__backfog"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { mapMutations, mapState } from 'vuex'
import config from '@/utils/appConfig'
import GlBlockchainIcon from '@/components/gl-blockchain-icon.vue'
import GlIcon from '@/components/gl-icon.vue'

//mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'

export default {
  components: {
    vSelect,
    GlBlockchainIcon,
    GlIcon,
  },
  mixins: [deviceWidthMixin],
  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: null,
    },
    iconHeight: {
      type: Number,
      default: 16,
    },
    iconWidth: {
      type: Number,
      default: 16,
    },
    iconAfter: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    padder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSelectOpen: false,
      coin: {},
    }
  },
  computed: {
    ...mapState('analytics', ['coinType', 'currencyList']),
    hasMultyCoin() {
      return config.VUE_APP_COIN_TYPE
    },
  },
  watch: {
    coinType: {
      handler(coin) {
        this.changeCoin(coin)
      },
      immediate: true,
    },
    currencyList: {
      handler(coin) {
        this.changeCoin(coin)
      },
    }
  },
  methods: {
    ...mapMutations({
      SET_COIN_TYPE: 'analytics/SET_COIN_TYPE',
      SET_COIN_DATA: 'analytics/SET_COIN_DATA',
    }),
    handleCoinSelect(data) {
      this.SET_COIN_TYPE(data.key)
      this.SET_COIN_DATA(data)
      this.$emit('change', data)
    },
    changeCoin(coin) {
      this.coin =
        this.currencyList.find(item => item.key === coin) ||
        this.currencyList[0]
    },
    closeSelect() {
      this.isSelectOpen = false
      this.$refs.coinSelectBaseRef?.$refs.search?.blur()
    },
  },
}
</script>

<style>
.coin-select-base {
  width: 178px;
  height: 40px;
  background: transparent;
  border: 1px solid var(--Basic-100);
  border-radius: var(--Corner-radius-M);
  box-shadow: none;
}
.coin-select-base .vs__dropdown-toggle {
  min-height: 38px;
  padding: 0 16px 0 8px !important;
  background-color: var(--Basic-100);
  border-radius: var(--Corner-radius-M);
}
.coin-select-base .vs__selected-options,
.coin-select-base .vs__selected,
.coin-select-base .vs__actions,
.coin-select-base .vs__search {
  margin: 0;
  padding: 0;
}
.coin-select-base .vs__dropdown-option,
.coin-select-base .vs__selected {
  gap: 8px;
}

.coin-select-base.vs--open {
  border: 1px solid var(--Basic-900);
}
.coin-select-base.vs--open .vs__selected {
  opacity: 1;
  position: relative;
}

.coin-select-base .vs__dropdown-option {
  min-height: 48px;
  margin: 0;
  padding: 0 0 0 16px !important;
}
.gl-input__backfog {
  background-color: var(--Background-tint);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

.coin-select-base__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid var(--Basic-100);
}
.coin-select-base__header-text {
  font-weight: 700;
  font-size: 20px;
  line-height: 1;
  color: var(--Basic-900);
}
.coin-select-base__header-icon {
  padding: 4px;
}

@media (max-width: 799px) {
  .coin-select-base {
    width: 64px;
    border-radius: var(--Corner-radius-M) 0 0 var(--Corner-radius-M);
  }
  .coin-select-base .vs__dropdown-toggle {
    padding: 0 0 0 8px !important;
    border-radius: var(--Corner-radius-M) 0 0 var(--Corner-radius-M);
  }
  .coin-select-base.vs--open {
    border: 1px solid var(--Basic-100);
  }

  .vs__dropdown-menu {
    width: 100% !important;
    border-radius: var(--Corner-radius-XL) var(--Corner-radius-XL) 0 0 !important;
    position: fixed;
    right: auto !important;
    left: 0 !important;
    top: auto !important;
    bottom: 0 !important;
    z-index: 100;
  }
}
</style>
